module.exports = __FOREMAN_VENDOR__CLASSNAMES__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__CLASSNAMES__"
// module id = classnames
// module chunks = 0